<template>
    <div class="cc-post-office-package" @click.prevent.stop>
        <div class="cc-post-office-package__header">
            <div class="cc-post-office-package__title" v-if="packageForPostOffice.selectedPostOffice.id">{{ packageForPostOffice.selectedPostOffice.name }}</div>
            <button class="cc-button cc-button--delivery-branch" @click.stop="openPostOfficeWidget">{{ deliveryBranchButtonName }}</button>
        </div>
        <div class="cc-post-office-package__main" v-if="shouldPostOfficeWidgetBeShown">
            <div class="cc-popup cc-popup--with-overlay" v-bind:class="{'cc-show': shouldPostOfficeWidgetBeShown}" @click.prevent.stop="closePostOfficeWidget">
                <div class="cc-popup__content" @click.prevent.stop>
                    <div class="cc-popup__header">
                        <div class="cc-popup__title">{{ translations['Search for post office'] }}</div>
                    </div>
                    <div class="cc-popup__main">
                        <div class="cc-form-input">
                            <label for="packageForPostOffice.search.postalCode" class="cc-label cc-label--text">{{ translations['Postal code'] }}*</label>
                            <input id="packageForPostOffice.search.postalCode" type="email" name="packageForPostOffice.search.postalCode" class="cc-input cc-input--text" v-model="searchPostalCode">
                        </div>
                        <div class="cc-form-input">
                            <label for="packageForPostOffice.search.city" class="cc-label cc-label--text">{{ translations['City'] }}*</label>
                            <input id="packageForPostOffice.search.city" type="email" name="packageForPostOffice.search.city" class="cc-input cc-input--text" v-model="searchCity">
                        </div>
                        <table class="cc-table" v-if="packageForPostOffice.postOffices.length > 0">
                            <thead class="cc-table__thead">
                                <tr class="cc-table__tr">
                                    <th class="cc-table__th">
                                        {{ translations['Post office'] }}
                                    </th>
                                    <th class="cc-table__th">
                                        {{ translations['Street'] }}
                                    </th>
                                    <th class="cc-table__th">
                                        {{ translations['Controls'] }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="cc-table__tbody">
                                <tr v-for="postOffice in packageForPostOffice.postOffices" v-bind:key="postOffice.id" class="cc-table__tr">
                                    <td class="cc-table__td">
                                        {{ postOffice.naz_prov }}
                                    </td>
                                    <td class="cc-table__td">
                                        {{ postOffice.adresa }}
                                    </td>
                                    <td class="cc-table__td">
                                        <button class="cc-button cc-button--select-post-office" :data-post-office-id="postOffice.id" :data-post-office-name="postOffice.naz_prov" @click.prevent.stop="selectPostOfficeBranch">{{ translations['Select branch'] }}</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="cc-popup__footer">
                        <button class="cc-button cc-button--popup-cancel" @click.prevent.stop="closePostOfficeWidget">{{ translations['Cancel'] }}</button>
                        <button class="cc-button cc-button--popup-ok" @click.prevent.stop="searchPostOffices">{{ translations['Search'] }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        computed: {
            ...mapState({
                translations: state => state.translations,
                packageForPostOffice: state => state.packageForPostOffice,
            }),
            deliveryBranchButtonName: function () {
                return this.packageForPostOffice.selectedPostOffice.id ? this.translations['Change'] : this.translations['Select branch'];
            },
        },
        data: function () {
            return {
                shouldPostOfficeWidgetBeShown: false,
                searchPostalCode: '',
                searchCity: '',
            };
        },
        methods: {
            openPostOfficeWidget: function () {
                this.shouldPostOfficeWidgetBeShown = true;
            },
            closePostOfficeWidget: function () {
                this.shouldPostOfficeWidgetBeShown = false;
            },
            searchPostOffices: function () {
                this.$store.commit('SET_PACKAGE_FOR_POST_OFFICE_SEARCH_POSTAL_CODE', this.searchPostalCode);
                this.$store.commit('SET_PACKAGE_FOR_POST_OFFICE_SEARCH_CITY', this.searchCity);
                this.$store.dispatch('LOAD_POST_OFFICES');
            },
            selectPostOfficeBranch: function (event) {
                this.$store.commit('SET_PACKAGE_FOR_POST_OFFICE_SELECTED_POST_OFFICE', {id: event.currentTarget.dataset.postOfficeId, name: event.currentTarget.dataset.postOfficeName});
                this.closePostOfficeWidget();
                this.$store.commit('SET_PACKAGE_FOR_POST_OFFICE_SEARCH_POSTAL_CODE', '');
                this.$store.commit('SET_PACKAGE_FOR_POST_OFFICE_SEARCH_CITY', '');
                this.$store.commit('SET_PACKAGE_FOR_POST_OFFICE_POST_OFFICES', {});
            },
        },
        name: 'PostOfficePackage',
        props: [
            'carrier'
        ],
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/components/post-office-package";
</style>
